import type { Project } from "../../api/useProjects";

export function getLatestActiveAnalysisDate(project: Project) {
  const latestActiveAnalysisDate = project.analysesAggregate?.latestActiveAnalysis?.date;

  return latestActiveAnalysisDate ? new Date(latestActiveAnalysisDate).getTime() : null;
}
